import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Building2,
  Clock,
  Eye,
  CalendarCheck,
  BarChart3,
  Star,
  Bell,
  CreditCard,
  User,
  Headphones,
  Dumbbell,
  Sparkles
} from "lucide-react";

const TRUST_TIP = "Keep your gym listing complete — verified profiles with photos and full amenities get more member bookings.";

export const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/my-gym", label: "My Gym", icon: Building2 },
  { to: "/pricing-slots", label: "Slots", icon: Clock },
  { to: "/listing-preview", label: "Listing Preview", icon: Eye },
  { to: "/bookings", label: "Bookings", icon: CalendarCheck },
  { to: "/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/reviews", label: "Reviews", icon: Star },
  { to: "/notifications", label: "Notifications", icon: Bell },
  { to: "/payments", label: "Payments & Subscription", icon: CreditCard },
  { to: "/profile", label: "Profile", icon: User },
  { to: "/support", label: "Support", icon: Headphones }
];

export default function Sidebar({ isCollapsed, onNavigate }) {
  return (
    <aside
      className={`fixed top-0 left-0 bottom-0 z-40 flex flex-col justify-between transition-all duration-300 ease-in-out
        bg-[linear-gradient(180deg,#ffffff_0%,#f8f9fa_100%)] dark:bg-[linear-gradient(180deg,#0d1117_0%,#161b22_50%,#0d1117_100%)]
        border-r border-[#e8eaed] dark:border-white/[0.06]
        shadow-[2px_0_16px_rgba(60,64,67,0.06)] dark:shadow-[4px_0_24px_rgba(0,0,0,0.35)]
        ${isCollapsed ? "w-[72px]" : "w-[256px]"}`}
    >
      {/* Logo header */}
      <div className="h-16 px-4 flex items-center justify-between shrink-0 border-b border-[#e8eaed] dark:border-white/[0.06]">
        {!isCollapsed ? (
          <div className="flex items-center gap-3 overflow-hidden">
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
              style={{ background: "linear-gradient(135deg, #1a73e8 0%, #4285f4 60%, #8ab4f8 100%)", boxShadow: "0 4px 14px rgba(26,115,232,0.45)" }}
            >
              <Dumbbell className="w-[18px] h-[18px] text-white" />
            </div>
            <div className="flex flex-col leading-tight overflow-hidden">
              <span className="font-bold text-[15px] tracking-tight text-[#202124] dark:text-white whitespace-nowrap">GymPortal</span>
              <span className="text-[10px] font-semibold uppercase tracking-widest text-[#9aa0a6] dark:text-white/35">Owner Console</span>
            </div>
          </div>
        ) : (
          <div className="w-full flex justify-center">
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center"
              style={{ background: "linear-gradient(135deg, #1a73e8 0%, #4285f4 100%)", boxShadow: "0 4px 14px rgba(26,115,232,0.45)" }}
            >
              <Dumbbell className="w-[18px] h-[18px] text-white" />
            </div>
          </div>
        )}
      </div>

      {/* Nav items */}
      <div className="flex-1 overflow-y-auto py-3 px-2 space-y-1" style={{ scrollbarWidth: "none" }}>
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={onNavigate}
              title={isCollapsed ? item.label : undefined}
              className={({ isActive }) =>
                `relative w-full flex items-center gap-3 px-3 py-[9px] rounded-xl text-[13px] font-medium transition-all cursor-pointer group ${
                  isCollapsed ? "justify-center" : ""
                } ${
                  isActive
                    ? "bg-[#e8f0fe] dark:bg-[#1a73e8]/[0.18] text-[#1a73e8] dark:text-[#8ab4f8] shadow-[inset_0_0_0_1px_rgba(26,115,232,0.18)] dark:shadow-[inset_0_0_0_1px_rgba(26,115,232,0.25)]"
                    : "text-[#5f6368] dark:text-white/55 hover:bg-[#f1f3f4] dark:hover:bg-white/5 hover:text-[#202124] dark:hover:text-white/85"
                }`
              }
            >
              <Icon className="w-[18px] h-[18px] shrink-0" />
              {!isCollapsed && <span className="truncate">{item.label}</span>}
            </NavLink>
          );
        })}
      </div>

      {/* Tip card */}
      {!isCollapsed && (
        <div className="p-3 shrink-0">
          <div className="rounded-2xl p-3.5 bg-[#e8f0fe] dark:bg-[#1a73e8]/10 border border-[#c8dcfb] dark:border-[#1a73e8]/20">
            <div className="flex items-center gap-1.5 text-[11px] font-bold text-[#1a73e8] dark:text-[#8ab4f8] mb-1">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Tip</span>
            </div>
            <p className="text-[11px] leading-relaxed text-[#5f6368] dark:text-white/50">{TRUST_TIP}</p>
          </div>
        </div>
      )}
    </aside>
  );
}
